// @ts-ignore
import image1 from "@images/outcomes-images/1.webp"
// @ts-ignore
import image2 from "@images/outcomes-images/2.webp"
// @ts-ignore
import image3 from "@images/outcomes-images/3.webp"
// @ts-ignore
import image4 from "@images/outcomes-images/4.webp"

export const FLEXIBLE_TIME_TRACKING = {
  beforeTitle: "Flexible time tracking",
  title: undefined,
  description: undefined,
  linkText: "Learn more about smart time tracking",
  href: "/features/time-tracking-app",
  imageFirst: false,
  image: image1,
  collapseItems: [
    {
      title: "Multiple ways to track time",
      description:
        "Use a running timer, add time manually, or record breaks separately. Switch methods without changing your workflow.",
    },
    {
      title: "Billable status built into every entry",
      description:
        "Mark entries as billable or non-billable as time is recorded. The same data feeds reporting, billing, and profitability.",
    },
    {
      title: "Connected work records",
      description:
        "Add tasks, tags, and project assignments to every entry. Time stays tied to the work behind it instead of becoming another disconnected log.",
    },
  ],
}

export const TIME_TO_PROJECT_PROFITABILITY = {
  beforeTitle: "Connect time to project profitability",
  title: undefined,
  description: undefined,
  // linkText: "Learn about project financials",
  linkText: undefined,
  href: "",
  imageFirst: true,
  image: image2,
  collapseItems: [
    {
      title: "Project costs, revenue, and margins",
      description: "See tracked hours, costs, revenue, and margins per project in a single view.",
    },
    {
      title: "Rates that follow the work",
      description:
        "Apply workspace, user, or project-specific rates automatically for consistent cost and billing calculations.",
    },
    {
      title: "Team and contributor breakdowns",
      description:
        "See how costs, billable work, and revenue are distributed across projects, teams, and individual contributors.",
    },
    {
      title: "Reports",
      description:
        "Move from high-level summaries to detailed project data using filters for clients, projects, teams, users, and time periods.",
    },
  ],
}

export const CAPACITY_AND_WORKLOAD = {
  showBlur: false,
  beforeTitle: "Capacity and workload",
  title: undefined,
  description: undefined,
  linkText: "Learn how teams manage workload",
  href: "/features/team-management",
  imageFirst: false,
  image: image3,
  collapseItems: [
    {
      title: "Capacity planning",
      description:
        "Compare planned availability with actual hours to see who is overloaded, underutilized, or approaching capacity.",
    },
    {
      title: "Work patterns throughout the day",
      description:
        "Review clock-ins, clock-outs, and work sessions to see how working time is distributed throughout the day.",
    },
    {
      title: "Project allocation",
      description:
        "See how time is distributed across projects for each team member. Identify people spread across too many priorities or spending most of their time on a single project.",
    },
  ],
}

export const PRIVACY_FIRST_BY_DESIGN = {
  beforeTitle: "Privacy-first by design",
  title: undefined,
  description: undefined,
  // linkText: "Learn about privacy features",
  linkText: undefined,
  href: "/team-management",
  imageFirst: true,
  image: image4,
  collapseItems: [
    {
      title: "Transparent time tracking",
      description:
        "Traqq only records time that users choose to track. There is no hidden monitoring or background surveillance.",
    },
    {
      title: "No screenshots or activity scores",
      description:
        "Traqq does not capture screens, measure activity levels, or attempt to evaluate how people work.",
    },
    {
      title: "Roles and permissions",
      description:
        "Control access to time, project, financial, and reporting data with role-based permissions.",
    },
  ],
}

export const transformSections = [
  FLEXIBLE_TIME_TRACKING,
  TIME_TO_PROJECT_PROFITABILITY,
  CAPACITY_AND_WORKLOAD,
  PRIVACY_FIRST_BY_DESIGN,
]

export type TransformSectionsType = (typeof transformSections)[number]
